import { render } from "./PendingOrderStock.vue?vue&type=template&id=5361abb0&scoped=true"
import script from "./PendingOrderStock.vue?vue&type=script&lang=js"
export * from "./PendingOrderStock.vue?vue&type=script&lang=js"

import "./PendingOrderStock.vue?vue&type=style&index=0&id=5361abb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5361abb0"]])

export default __exports__